// ============================================================
//  legalConfig.js
//  แก้ไขเนื้อหา Terms & Privacy ได้ที่นี่ที่เดียว
// ============================================================

const LEGAL_CONFIG = {
  companyName: "EURNGKUM Guest House",
  contactEmail: "privacy@eurngkum.com",

  terms: {
    title: "เงื่อนไขการให้บริการ",
    sections: [
      {
        heading: "1. การยอมรับเงื่อนไข",
        body: "การใช้บริการ EURNGKUM Guest House ถือว่าท่ฤานยอมรับเงื่อนไขการให้บริการฉบับนี้"
      },
      {
        heading: "2. การใช้บริการ",
        body: "ท่านตกลงใช้บริการเพื่อวัตถุประสงค์ที่ถูกกฎหมายเท่านั้น และต้องไม่กระทำการฉ้อโกง หรือกิจกรรมที่ผิดกฎหมายใดๆ"
      },
      {
        heading: "3. ความรับผิดชอบของบัญชีผู้ใช้",
        body: "ท่านมีหน้าที่รับผิดชอบในการรักษาความลับของข้อมูลบัญชีและกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้บัญชีของท่าน"
      },
      {
        heading: "4. การจองและการยกเลิก",
        body: "การจองขึ้นอยู่กับห้องว่าง นโยบายการยกเลิกจะแตกต่างกันตามประเภทห้องและจะระบุไว้อย่างชัดเจนเมื่อทำการจอง"
      },
      {
        heading: "5. การชำระเงิน",
        body: "การชำระเงินทั้งหมดต้องดำเนินการผ่านช่องทางที่ได้รับอนุมัติเท่านั้น ราคาอาจเปลี่ยนแปลงได้โดยไม่ต้องแจ้งล่วงหน้า"
      },
      {
        heading: "6. ข้อจำกัดความรับผิด",
        body: "EURNGKUM Guest House ไม่รับผิดชอบต่อความเสียหายทางอ้อมที่เกิดจากการใช้บริการของท่าน"
      },
      {
        heading: "7. การแก้ไขเงื่อนไข",
        body: "เราสงวนสิทธิ์ในการแก้ไขเงื่อนไขเหล่านี้ได้ตลอดเวลา การใช้บริการต่อเนื่องถือว่ายอมรับเงื่อนไขที่แก้ไขแล้ว"
      }
    ]
  },

  privacy: {
    title: "นโยบายความเป็นส่วนตัว",
    sections: [
      {
        heading: "1. ข้อมูลที่เราเก็บรวบรวม",
        body: "เราเก็บข้อมูลส่วนบุคคลที่ท่านให้ไว้ เช่น ชื่อ อีเมล เบอร์โทรศัพท์ เอกสารระบุตัวตน และข้อมูลการชำระเงิน"
      },
      {
        heading: "2. การใช้ข้อมูลของท่าน",
        body: "ข้อมูลของท่านถูกนำไปใช้เพื่อดำเนินการจอง ส่งการยืนยันการจอง ให้บริการลูกค้า และปรับปรุงบริการของเรา"
      },
      {
        heading: "3. การจัดเก็บและความปลอดภัย",
        body: "ข้อมูลของท่านถูกจัดเก็บอย่างปลอดภัยด้วยการเข้ารหัสมาตรฐานอุตสาหกรรม เราใช้มาตรการทางเทคนิคและองค์กรที่เหมาะสมในการปกป้องข้อมูล"
      },
      {
        heading: "4. การแชร์ข้อมูล",
        body: "เราไม่ขายหรือให้เช่าข้อมูลส่วนบุคคลของท่านแก่บุคคลที่สาม เราอาจแชร์ข้อมูลกับผู้ให้บริการที่เชื่อถือได้ภายใต้ข้อตกลงรักษาความลับ"
      },
      {
        heading: "5. คุกกี้",
        body: "เราใช้คุกกี้เพื่อปรับปรุงประสบการณ์การเรียกดูของท่าน ท่านสามารถปิดการใช้งานคุกกี้ผ่านการตั้งค่าเบราว์เซอร์ได้"
      },
      {
        heading: "6. การเก็บรักษาข้อมูล",
        body: "เราเก็บข้อมูลส่วนบุคคลของท่านตราบเท่าที่จำเป็นตามวัตถุประสงค์ที่ระบุในนโยบายนี้ หรือตามที่กฎหมายกำหนด"
      },
      {
        heading: "7. สิทธิ์ของท่าน",
        body: "ท่านมีสิทธิ์เข้าถึง แก้ไข หรือลบข้อมูลส่วนบุคคลของท่าน ติดต่อเราที่: privacy@eurngkum.com"
      }
    ]
  }
};

export default LEGAL_CONFIG;